import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingPrice, CarRentalRecord } from '@pulpo/pulpo-models';

@Component({
  selector: 'booking-record-car-rental',
  templateUrl: './booking-record-car-rental.component.html',
  styleUrls: ['./booking-record-car-rental.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BookingRecordCarRentalComponent {
  @Input() carRentalRecord: CarRentalRecord;
  @Input() bookingPrice: BookingPrice;

  get basePrice(): number {
    return this.bookingPrice?.vehiclePrice ?? this.carRentalRecord.carRentalReferencePrice;
  }

  get supplementPrice(): number {
    return this.bookingPrice?.vehicleSupplementPrice ?? this.carRentalRecord.carRentalSupplement;
  }

  get totalPrice(): number {
    return this.bookingPrice != null
      ? (this.bookingPrice.vehiclePrice ?? 0) + (this.bookingPrice.vehicleSupplementPrice ?? 0)
      : this.carRentalRecord.carRentalTotalPrice;
  }
}
